import Link from "next/link";
import FundamenteiWithText from "../branding/FundamenteiWithText";

interface IFundamenteiWithTextLayoutProps {
  children: any;
}

export default function FundamenteiWithTextLayout({ children }: IFundamenteiWithTextLayoutProps) {
  return (
    <>
      <header className="mx-auto mt-10 max-w-screen-legacyDesktop text-center">
        <Link href="/" title="Fundamentei" className="inline-flex">
          <FundamenteiWithText width={260} height={38} />
        </Link>
      </header>

      {children}
    </>
  );
}
